import React, { useEffect, useState } from 'react'
import { Container, Form, Table, Tabs, Tab } from 'react-bootstrap'
import { CATEGORIES_COLLECTION } from '../../firebase'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'

const PreviewCategory = () => {

    const history = useHistory()

    const [items, setItems] = useState([])

    const [search, setSearch] = useState('')

    const filteredItems = items.filter((item) => {

        let canReturnItem = false;

        const searchLowerCase = search.toLowerCase()

        if (item?.title_en && item.title_en.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.title_sr && item.title_sr.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }

        return canReturnItem
    })

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await CATEGORIES_COLLECTION.get()
            const items = []
            snapshot.forEach(doc => {
                items.push(doc.data())
            })
            setItems(items)
        }

        getItems()

    }, [])

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="preview-category" className="mb-3" transition={false}>
                    <Tab eventKey="preview-category" title="Pregled kategorija">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Pretraga</Form.Label>
                                <Form.Control type="search" placeholder="Unesite pojam za pretragu..." onChange={(e) => setSearch(e.target.value)} />
                                <Form.Text className="text-muted">
                                    Pretražite prema polju Naslov (EN) i Naslov (SR).
                                </Form.Text>
                            </Form.Group>
                        </Form>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Uredi / obriši</th>
                                    <th>ID</th>
                                    <th>Kategorija</th>
                                    <th>Datum</th>
                                    <th>Naslov (EN)</th>
                                    <th>Naslov (SR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <div>
                                                <Link to={`/edit-category/${item._id}`}>
                                                    Uredi
                                                </Link>
                                                <br />
                                                <Link to={`/delete-category/${item._id}`}>
                                                    Obriši
                                                </Link>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item._id}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.category}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.date ? moment(item.date.toDate()).format('DD/MM/YYYY') : '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_sr}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="add-category" title={<div onClick={() => history.push('/add-category')}>Dodaj</div>} />
                    <Tab eventKey="edit-category" title='Uredi' disabled />
                    <Tab eventKey="delete-category" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default PreviewCategory
